/** Backend connector display name (must match workspace connector configuration). */
export const EMAIL_CONNECTOR_NAME = 'Mailtrap Connector';

/** Connector flow names (must match workspace connector flow configuration). */
export const EMAIL_CONNECTOR_FLOW_NAME = 'Mailtrap Send Flow';
export const EMAIL_TEMPLATE_CONNECTOR_FLOW_NAME = 'Mailtrap Template Insert Flow';
export const EMAIL_TEMPLATE_EDIT_FLOW_NAME = 'Mailtrap Template Edit Flow';
export const EMAIL_TEMPLATE_DELETE_FLOW_NAME = 'Mailtrap Template Delete Flow';
